import React from 'react'
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay
} from '@chakra-ui/react'
import IssuePaymentRefundForm from './Form'
import { RefundInfoType } from '../../types'

const IssuePaymentRefundModal: React.FC<
  React.PropsWithChildren<{
    close: () => void
    isOpen: boolean
    onSuccess?: () => void | Promise<void>
    refundInfo: RefundInfoType
  }>
> = ({ close, isOpen, onSuccess, refundInfo }) => {
  const isBuildiumRefund = refundInfo.paymentSource === 'buildium'

  return (
    <Modal isCentered isOpen={isOpen} onClose={close} size='lg'>
      <ModalOverlay />
      <ModalContent mx={4}>
        <ModalHeader py={4}>
          {isBuildiumRefund ? 'Record Buildium refund in Hudson' : 'Issue a payment refund'}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={4} pt={0}>
          <IssuePaymentRefundForm
            key={`${refundInfo.paymentId}:${isOpen ? 'open' : 'closed'}`}
            onCancel={close}
            onSubmit={onSuccess ?? close}
            refundInfo={refundInfo}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default IssuePaymentRefundModal
